"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function agrs(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M14.8159 13.0008C16.5004 10.3616 17.8121 6.00034 17.8121 6.00034L15.0034 6.63709L13.9751 10.2746C13.8784 7.54759 12.0086 6.54934 12.0086 6.54934C10.5109 5.81959 9.17587 6.14059 8.21362 6.64234C7.02262 7.26184 6.15637 8.34184 5.74162 9.58534C5.15212 11.3546 5.22412 13.3398 5.30212 14.2383C5.33362 14.6598 5.42662 15.0746 5.57962 15.4706C6.61312 18.1503 9.47587 17.9981 9.47587 17.9981C12.0986 17.9051 13.6924 14.8166 13.6924 14.8166L14.4439 17.0876C15.1174 18.2268 16.6091 17.8001 16.9159 17.7363C16.9699 17.7243 17.0179 17.7183 17.0726 17.7063L18.7496 17.4506V16.7208C15.0986 16.8198 14.8159 13.0016 14.8159 13.0016V13.0008ZM11.2616 15.7458C11.0358 15.9773 10.7511 16.1428 10.4381 16.2243C9.75787 16.3938 9.23512 16.1081 8.87437 15.7578C8.47134 15.3508 8.19538 14.8354 8.08012 14.2743C7.41862 10.5318 8.33287 8.89159 8.94037 8.13784C9.10584 7.92654 9.31917 7.7576 9.56275 7.64493C9.80634 7.53227 10.0732 7.47911 10.3414 7.48984C12.6994 7.61284 13.2289 12.5463 13.2289 12.5463C12.5614 14.2976 11.7011 15.3138 11.2616 15.7458Z", fill: color }));
}
exports["default"] = agrs;
//# sourceMappingURL=agrs.js.map